import PrivateRoute from "../../withPrivateRoute"
import { Header, IconCardComponent } from "../../components"
import styled from "styled-components"
import { theme } from "@project/shared"
import { useTranslation } from "react-i18next"
import UsersIcons from "../../public/assets/icons/users.svg"
import CommunityIcon from "../../public/assets/icons/community.svg"
import YenIcon from "../../public/assets/icons/yen.svg"
import Head from "next/dist/shared/lib/head"
import { useQuery } from "react-query"
import { fetchDashboardValues } from "../../services"

const Container = styled.div`
  background-color: ${theme.background.colorSecondary3};
  min-height: 100vh;
  .container {
    margin: 35px;
    border: solid 1px ${theme.border.colorSecondary1};
    padding: 20px;
    border-radius: 5px;
    background-color: ${theme.background.colorSecondary1};
    padding-top: 25px;
    .displayCard1,
    .displayCard2 {
      display: flex;
      flex-direction: row;
    }
    .displayCard1 {
      justify-content: space-evenly;
    }
    .displayCard2 {
      justify-content: center;
      margin-top: 67px;
    }
  }
`
const HomePage = () => {
  const { t } = useTranslation()
  const { data: transactionData } = useQuery(
    ["merchant-data"],
    fetchDashboardValues,
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        return {
          totalRegisteredCustomer: data.todays_registrant_number,
          totalVoucherSold: data.todays_trading_amount,
          totalVoucherRedeem: data.todays_topup_amount,
        }
      },
    }
  )
  return (
    <Container>
      <Head>
        <title>{t("Home")}</title>
      </Head>
      <Header title={t("Home")} />
      <div className={"container"}>
        <div className={"displayCard1"}>
          <IconCardComponent
            label={t("resident")}
            icon={<UsersIcons />}
            iconHeight={61}
            iconWidth={61}
            valueContent={
              transactionData?.totalRegisteredCustomer
                ? Number(
                    transactionData?.totalRegisteredCustomer
                  )?.toLocaleString() + " 人"
                : "0 人"
            }
          />
          <IconCardComponent
            label={t("service_sold")}
            icon={<CommunityIcon />}
            iconHeight={61}
            iconWidth={57}
            valueContent={
              transactionData?.totalVoucherSold
                ? Number(transactionData?.totalVoucherSold)?.toLocaleString() +
                  " 円"
                : "0 円"
            }
          />
        </div>
        <div className={"displayCard2"}>
          <IconCardComponent
            label={t("top_up")}
            icon={<YenIcon />}
            iconHeight={54.25}
            iconWidth={54.25}
            valueContent={
              transactionData?.totalVoucherRedeem
                ? Number(
                    transactionData?.totalVoucherRedeem
                  )?.toLocaleString() + " 円"
                : "0 円"
            }
          />
        </div>
      </div>
    </Container>
  )
}
export default PrivateRoute(HomePage)
